import React from 'react';
import { Box, Card, CardContent, Avatar, Typography } from '@mui/material';

const ProfileCard = ({ primaryText, secondaryText, imageUrl }) => {
  return (
    <Card sx={{ maxWidth: 300, borderRadius: 2, boxShadow: 3 }}>
      <CardContent sx={{ display: 'flex', alignItems: 'center', padding: 2 }}>
        <Avatar
          alt={primaryText}
          src={imageUrl || ''}
          sx={{ width: 60, height: 60, bgcolor: 'primary.main', fontSize: 24, marginRight: 2 }}
        >
          {!imageUrl && primaryText.charAt(0)}
        </Avatar>
        <Box>
          <Typography variant="h6"
          sx={{
            display: '-webkit-box',
            WebkitBoxOrient: 'vertical',
            WebkitLineClamp: 2,
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            fontWeight: 600,
            fontSize: '1rem'
          }}
          >{primaryText}</Typography>
          <Typography variant="body2" color="textSecondary"
            sx={{
            display: '-webkit-box',
            WebkitBoxOrient: 'vertical',
            WebkitLineClamp: 3,
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            fontSize: '0.875rem'
          }}>
          {secondaryText}
        </Typography>
      </Box>
      </CardContent>
    </Card>
  );
};

export default ProfileCard;
